import Link from 'next/link';
import { FC } from 'react';
import { LandingImageTextTileItemStoryblok } from 'storyblok-types';
import { Image } from 'atoms/Image/Image';
import { P } from 'atoms/Typography';
import { RichTextMarkdown } from '../RichText';
import styles from './styles.module.css';

const ImageAndTitle: FC<
  Pick<LandingImageTextTileItemStoryblok, 'image' | 'title'>
> = ({ image, title }) => {
  return (
    <>
      <Image src={image.filename} alt={image?.alt} className={styles.img} />
      <h3 className={styles.title}>{title}</h3>
    </>
  );
};

export const LandingImageTextTileItem: FC<{
  blok: LandingImageTextTileItemStoryblok;
}> = ({ blok }) => {
  return (
    <div className={styles.item}>
      {blok.link ? (
        <Link href={blok.link} className={styles.link}>
          <ImageAndTitle image={blok.image} title={blok.title} />
        </Link>
      ) : (
        <ImageAndTitle image={blok.image} title={blok.title} />
      )}
      {blok.richText && (
        <div className={styles.richText}>
          <RichTextMarkdown
            text={blok.richText}
            components={{
              p: ({ children }) => <P className={styles.p}>{children}</P>,
            }}
          />
        </div>
      )}
    </div>
  );
};
